import { TQualityBand } from '../models'

const QUALITY_BAND_COLORS: Record<TQualityBand, string> = {
  Low: 'var(--color-danger-light)',
  Moderate: 'var(--color-warning-main)',
  High: 'var(--color-success-main)',
}

export const getQualityBandColor = (band: TQualityBand) => QUALITY_BAND_COLORS[band]
